import React from "react";
import Typography from "material-ui/Typography";
import TileIcon from "./TileIcon";
import FuelEstimateIcon from "./../../../images/combustible_calculado.svg";
import LocalGasStationIcon from "material-ui-icons/LocalGasStation";
import DistanceTraveledIcon from "./../../../images/driving/summary-trips.png";
import { Dialog } from "material-ui";
const fakeData = {
  Costo: 3790,
  Kilometraje: 1789,
  Consumo: 189.51
};

const FuelConsumptionEstimateTile = props => {
  const { lang, data } = props;
  const fuelConsumed = {
    Costo: data.CombustiblesCalculados.reduce(
      (acum, val) => acum + val.CostoViaje,
      0
    ).toFixed(2),
    Kilometraje: data.CombustiblesCalculados.reduce(
      (acum, val) => acum + val.Kilometraje,
      0
    ).toFixed(0),
    Consumo: data.CombustiblesCalculados.reduce(
      (acum, val) => acum + val.ConsumoCombustible,
      0
    ).toFixed(2)
  };

  return (
    <div className="dashboard-tile">
      <TileIcon image={FuelEstimateIcon} color="#f38a21" />
      <div className="tile-header">{lang.CombustibleCalculado}</div>
      <div className="tile-body">
        <Typography
          style={{ marginTop: "1rem" }}
          align="left"
          color="textSecondary"
          variant="display2"
        >
          ${fuelConsumed.Costo}
        </Typography>
        <Typography
          style={{ marginTop: "1rem" }}
          align="left"
          color="textSecondary"
          variant="title"
        >
          <img className="consumed-tile-img" src={DistanceTraveledIcon} />
          {fuelConsumed.Kilometraje} Km
        </Typography>
        <Typography
          align="left"
          color="textSecondary"
          variant="title"
          classes={{ root: "subtitle" }}
        >
          <LocalGasStationIcon className="orange-icon" /> {fuelConsumed.Consumo}{" "}
          lts
        </Typography>
      </div>
      {/* <div className="tile-footer">
        <Typography align="left" color="textSecondary" variant="subheader">
          {fakeData.Kilometraje} Km {fakeData.Consumo} lts
        </Typography>{" "}
      </div> */}
    </div>
  );
};

const FuelConsumptionEstimateDetail = props => {
  const { data, isActive } = props;
  return <Dialog />;
};

export default FuelConsumptionEstimateTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/FuelConsumptionEstimateTile.js